import React from 'react';
import styles from './Eof.module.scss';
import { useTranslation } from '../../i18n/LanguageProvider';

const Eof = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.wrapper}>
      <div className={styles.line} />
      <div className={styles.text}>{t('common.end')}</div>
      <div className={styles.line} />
    </div>
  );
};

export default Eof;
